import { render, staticRenderFns } from "./ClassroomHeader.vue?vue&type=template&id=a38e02b8&scoped=true"
import script from "./ClassroomHeader.vue?vue&type=script&lang=js"
export * from "./ClassroomHeader.vue?vue&type=script&lang=js"
import style0 from "./ClassroomHeader.vue?vue&type=style&index=0&id=a38e02b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38e02b8",
  null
  
)

export default component.exports